/**
 * @generated SignedSource<<7f9b3abf5996f2eb05df27837c5bac6f>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
export type editorSnippetTenantQuery$variables = {||};
export type editorSnippetTenantQuery$data = {|
  +tenantSettings: ?{|
    +id: string,
  |},
|};
export type editorSnippetTenantQuery = {|
  response: editorSnippetTenantQuery$data,
  variables: editorSnippetTenantQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Tenant",
    "kind": "LinkedField",
    "name": "tenantSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "editorSnippetTenantQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "editorSnippetTenantQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "646f7752a49f814fe0c98f3ccf5dadc9",
    "id": null,
    "metadata": {},
    "name": "editorSnippetTenantQuery",
    "operationKind": "query",
    "text": "query editorSnippetTenantQuery {\n  tenantSettings {\n    id\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "89775883b4c52dc756278218c8c71b86";

export default node;
